import styles from '../scss/trading-education.scss';

const $ = window.jQuery;
const slider = $('.free-courses-slider');

$(document).ready(function (e) {
  if (slider.length) {
    slickify(e);

    $(window).resize(function () {
      $('.free-courses-slider')[0].slick.refresh();
    });
  }
});

function slickify(e) {
  $('.free-courses-slider').slick({
    slidesToShow: 3.5,
    infinite: false,
    arrows: false,
    swipeToSlide: true,
    focusOnSelect: false,
    touchThreshold: 20,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          centerMode: true,
          infinite: true,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 500,
        settings: {
          arrows: false,
          centerMode: true,
          infinite: true,
          slidesToShow: 1,
        },
      },
    ],
  });
}

const myModal = $('.free_course_modal');
let playerId = '';

myModal.on('shown.bs.modal', (e) => {
  // find the <video> inside the modal and play it unmuted
  const videoEl = $(e.currentTarget).find('video').get(0);
  if (videoEl) {
    playerId = videoEl.id;
    videoEl.muted = false;
    videoEl.play();
  }
});

myModal.on('hidden.bs.modal', () => {
  // pause and reset the video when modal closes
  const videoEl = document.getElementById(playerId);
  if (videoEl) {
    videoEl.pause();
    videoEl.currentTime = 0;
  }
});

let isSwipe = false;
let isChange = false;

$('.free-courses-slider').on('swipe', function (event, slick, direction) {
  isSwipe = true;
});

$('.free-courses-slider').on(
  'beforeChange',
  function (event, slick, currentSlide, nextSlide) {
    isChange = true;
  }
);

// open modal on click (but not on swipe/change)
$('.free-courses-slider .free-course-thumbnail').on('click', function () {
  if (!isSwipe && !isChange) {
    const modalId = $(this).attr('data-bs-target');
    $(modalId).modal('show');
  }
  isSwipe = false;
  isChange = false;
});

// autoplay & duration for accordion videos
$('.accordion').each(function (i) {
  const videoId = 'videoplayer' + (i + 1);
  const videoEl = document.getElementById(videoId);
  if (!videoEl) return;

  videoEl.muted = true;
  videoEl.play();

  if (!videoEl._durationProcessed) {
    videoEl._durationProcessed = true;
    videoEl._durationInterval = setInterval(() => {
      if (videoEl.duration && !isNaN(videoEl.duration)) {
        clearInterval(videoEl._durationInterval);
        $(this)
          .find('.time_duration')
          .text(formatTime(Math.floor(videoEl.duration)));
      } else {
        videoEl.pause();
      }
    }, 250);
  }
});

function formatTime(time) {
  var sec_num = parseInt(time, 10);
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - hours * 3600) / 60);
  var seconds = sec_num - hours * 3600 - minutes * 60;

  if (hours === 0) {
    hours = '';
  }
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  if (seconds < 10) {
    seconds = '0' + seconds;
  }
  return hours + (hours !== '' ? ':' : '') + minutes + ':' + seconds;
}
